module.exports = __webpack_public_path__ + "static/media/megan_tieu.e1fe73b3.png";